<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 08:40:45
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-01 09:34:44
 * @FilePath: \HomeTop\Transfor-website\src\components\pc\Header.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div>
    <div class="Heater">
      <div class="Heater-W">
        <div class="logo">
          <div @click="Home" class="logo_All">
            <img src="@/assets/pc/HomeTop/Home1.png" /><span>
              Transformers</span
            >
          </div>
        </div>

        <div class="Heater_menu">
          <!-- 连接外网模块开始 -->
          <div class="Testnet1">
            <div style="display: flex" @click="Home">
              <div class="nettit" :class="{ StartColor: Scolor === '1-1' }">
                Home
              </div>
            </div>
          </div>
          <!-- 连接外网模块结束 -->
          <!-- 连接外网模块开始 -->
          <div class="Testnet2">
            <!-- <div style="display: flex" @click="showTestbox1" :class="testflog1==true?'active':''"> -->
            <div style="display: flex" @click="showTestbox1">
              <div class="nettit">Blockchain</div>
              <div class="netselect">
                <img :src="testflog1 == true ? imgloga : imglogo" />
              </div>
            </div>
            <div
              class="testbox"
              v-show="testflog1"
              @mouseover="showTestbox1"
              @mouseout="hideTestbox1"
            >
              <div @click="BlockList" :class="{ StartColor: Scolor === '2-1' }">
                <span>Blocks</span>
              </div>

              <div
                @click="Transactions"
                :class="{ StartColor: Scolor === '2-2' }"
              >
                <span>Transactions</span>
              </div>
              <div @click="Contracts" :class="{ StartColor: Scolor === '2-3' }">
                <span>Contracts</span>
              </div>
            </div>
          </div>
          <!-- 连接外网模块结束 -->
          <!-- 连接外网模块开始 -->
          <div class="Testnet3">
            <div style="display: flex; width: 84px" @click="showTestbox2">
              <div class="nettit">Tokens</div>
              <div class="netselect">
                <!-- <img :src="imglogoa" /> -->
                <img :src="testflog2 == true ? imgloga : imglogo" />
              </div>
            </div>
            <div
              class="testbox"
              v-show="testflog2"
              @mouseover="showTestbox2"
              @mouseout="hideTestbox2"
            >
              <div @click="TopTokens" :class="{ StartColor: Scolor === '3-1' }">
                <span>Top Tokens</span>
              </div>

              <div @click="Tokens" :class="{ StartColor: Scolor === '3-2' }">
                <span>Tokens Transfers</span>
              </div>
            </div>
          </div>
          <!-- 连接外网模块结束 -->
          <!-- 连接外网模块开始 -->
          <div class="Testnet4">
            <div style="display: flex; width: 73px" @click="showTestbox3">
              <div class="nettit">NFTs</div>
              <div class="netselect">
                <!-- <img :src="imglogob" /> -->
                <img :src="testflog3 == true ? imgloga : imglogo" />
              </div>
            </div>
            <div
              class="testbox"
              v-show="testflog3"
              @mouseover="showTestbox3"
              @mouseout="hideTestbox3"
            >
              <div @click="NFTs" :class="{ StartColor: Scolor === '4-1' }">
                <span>Top NFTs</span>
              </div>

              <div @click="NFTslist" :class="{ StartColor: Scolor === '4-2' }">
                <span>Latest Transfers</span>
              </div>
            </div>
          </div>
          <!-- 连接外网模块结束 -->
          <!-- 连接外网模块开始 -->
          <div class="Testnet5" @click="validators">
            <div style="display: flex">
              <div class="nettit" :class="{ StartColor: Scolor === '5-1' }">
                Top validators
              </div>
            </div>
          </div>
          <!-- 连接外网模块结束 -->

          <!-- 连接外网模块开始 -->
          <div class="Testnet6">
            <div style="display: flex; width: 109px" @click="showTestbox4">
              <div class="nettit">Developers</div>
              <div class="netselect">
                <!-- <img :src="imglogoc" /> -->
                <img :src="testflog4 == true ? imgloga : imglogo" />
              </div>
            </div>
            <div
              class="testbox"
              v-show="testflog4"
              @mouseover="showTestbox4"
              @mouseout="hideTestbox4"
            >
              <div
                @click="Deployment"
                :class="{ StartColor: Scolor === '6-1' }"
              >
                <span>Contract Deployment</span>
              </div>

              <div @click="Verify" :class="{ StartColor: Scolor === '6-2' }">
                <span>Verify Contract</span>
              </div>

              <div @click="APIs" :class="{ StartColor: Scolor === '6-3' }">
                <span>APIs</span>
              </div>
            </div>
          </div>
          <!-- 连接外网模块结束 -->

          <!-- 连接外网模块开始 -->
          <div class="Testnet">
            <div style="display: flex" @click="showTestbox">
              <div class="nettit">Mainnet</div>
              <div class="netselect">
                <img :src="imglogo1" />
              </div>
            </div>
            <div
              class="testbox"
              v-show="testflog"
              @mouseover="showTestbox"
              @mouseout="hideTestbox"
            >
              <router-link to="/pc/index">
                <div class="Mainnet"><span>Mainnet</span></div>
              </router-link>
              <div class="Testnet"><span>Testnet</span></div>
            </div>
          </div>
          <!-- 连接外网模块结束 -->
          <!-- 注册登录模块开始 -->
          <div class="signs" @click="login" v-if="userEmail == null">
            Sign In
          </div>
          <!-- 注册登录模块结束 -->
          <!-- <router-link to="/pc/Ownership" v-else> -->
          <div class="loginafter" @click="loginafter" v-else>
            <img src="@/assets/pc/Logo/tu.png" />

            <div>{{ userEmail }}</div>
          </div>
          <!-- </router-link> -->
        </div>
        <!-- <Signup v-show="floaga"></Signup> -->
        <Signup
          v-show="flogb"
          :flogb="flogb"
          :floag="floag"
          @signups="signups($event)"
          @loginflog="loginflog($event)"
        ></Signup>
        <Login
          v-show="floag"
          :flogb="flogb"
          :flogc="flogc"
          :floag="floag"
          @loginflog="loginflog($event)"
          @signups="signups($event)"
          @repwd="repwd($event)"
          @emails="emails($event)"
        ></Login>
        <Resignup
          v-show="flogc"
          :flogc="flogc"
          :floag="floag"
          @repwd="repwd($event)"
          @back="back($event)"
        ></Resignup>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { getSubStr } from "@/utils/utils";
import Main from "@/components/m/Main.vue";
import Signup from "../../views/pc/Login/Signup.vue";
import Login from "../../views/pc/Login/Login.vue";
import Resignup from "../../views/pc/Login/Resignup.vue";
export default {
  data() {
    return {
      Scolor: "",
      testflog: false,
      testflog1: false,
      testflog2: false,
      testflog3: false,
      testflog4: false,
      imglogo: require("@/assets/pc/Logo/xia1.png"),
      imgloga: require("@/assets/pc/Logo/shang1.png"),

      imglogo1: require("@/assets/pc/Logo/xia.png"),
      list: [
        {
          name: "Home",
          id: 0,
        },
        {
          name: "Blockchain",
          id: 1,
        },
        { name: "Tokens", id: 2 },
        { name: "NFTs", id: 3 },
        {
          name: "Top validators",
          id: 4,
        },
        // {
        //   name: "Charts",
        // },
      ],
      flag: false,
      id: "",
      id1: "",
      id2: "",
      id3: "",
      id4: "",
      imgs: require("@/assets/pc/Index/shan.png"),
      imgs1: require("@/assets/pc/Index/xia.png"),
      images: require("@/assets/pc/Index/xia.png"),
      activeIndex: "",
      activeIndex2: "",
      floag: false, //登录
      flogb: false, //注册
      flogc: false, //重置密码
      userEmail: "",
      userId: "",
      url: "https://explorer.tfsc.io/tfscBrowser/user/",
      // url: "http://192.168.1.123:9200/tfscBrowser/user/",
      jwtToken: "",
      // floaga:false,
    };
  },

  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/pc/Index") {
          this.Scolor = "1-1";
          if (localStorage.getItem("email") == null) {
            if (to.query.userEmail !== undefined) {
              this.userEmail = getSubStr(to.query.userEmail, 0, 4);
            }
            this.userEmail = null;
          } else {
            this.userEmail = getSubStr(localStorage.getItem("email"), 0, 4);
          }
        } else if (to.path === "/pc/BlockList") {
          this.Scolor = "";
          this.Scolor = "2-1";
        } else if (to.path === "/pc/TransactionsList") {
          this.Scolor = "";
          this.Scolor = "2-2";
        } else if (to.path === "/pc/Contracts") {
          this.Scolor = "";
          this.Scolor = "2-3";
        } else if (to.path === "/pc/Tokens") {
          this.Scolor = "";
          this.Scolor = "3-1";
        } else if (to.path === "/pc/TokensList") {
          this.Scolor = "";
          this.Scolor = "3-2";
        } else if (to.path === "/pc/Topnfts") {
          this.Scolor = "";
          this.Scolor = "4-1";
        } else if (to.path === "/pc/NFTs") {
          this.Scolor = "";
          this.Scolor = "4-2";
        } else if (to.path === "/pc/TopValidators") {
          this.Scolor = "";
          this.Scolor = "5-1";
        } else if (to.path === "/pc/Deployment") {
          this.Scolor = "";
          this.Scolor = "6-1";
        } else if (to.path === "/pc/Verify") {
          this.Scolor = "";
          this.Scolor = "6-2";
        } else if (to.path === "/pc/Apis") {
          this.Scolor = "";
          this.Scolor = "6-3";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {
    if (
      this.userEmail !== "" ||
      this.userEmail !== null ||
      this.userEmail !== undefined
    ) {
      this.userEmail = localStorage.getItem("email");
      // console.log(this.userEmail);
      this.userId = localStorage.getItem("userId");
      this.jwtToken = localStorage.getItem("jwtToken");
      // console.log(this.userId);
      if (this.userEmail !== null) {
        this.userEmail = getSubStr(this.userEmail, 0, 4);
      }
    }

    //this.activeIndex = this.$route.path
  },
  beforeRouteLeave(to, from, next) {
    //  console.log("浏览器离开了");
  },
  beforeRouteUpdate(to, from, next) {
    // 在这里执行你想要的操作，比如更新组件的数据
    //  console.log("浏览器前进或后退按钮被点击");
    // 这里可以调用你的处理逻辑
  },
  components: {
    Signup,
    Login,
    Resignup,
    Main,
  },
  computed: {},
  methods: {
    showTestbox1() {
      this.testflog1 = true;
      // this.imglogo = require("@/assets/pc/Logo/shang1.png");
      this.testflog2 = false;
      this.testflog3 = false;
      this.testflog4 = false;
      this.testflog = false;
    },
    hideTestbox1() {
      this.testflog1 = false;
      // this.imglogo = require("@/assets/pc/Logo/xia1.png");
    },
    showTestbox2() {
      this.testflog2 = true;
      // this.imglogoa = require("@/assets/pc/Logo/shang1.png");
      this.testflog1 = false;
      this.testflog3 = false;
      this.testflog4 = false;
      this.testflog = false;
    },
    hideTestbox2() {
      this.testflog2 = false;
      // this.imglogoa = require("@/assets/pc/Logo/xia1.png");
    },
    showTestbox3() {
      this.testflog3 = true;
      // this.imglogob = require("@/assets/pc/Logo/shang1.png");
      this.testflog1 = false;
      this.testflog2 = false;
      this.testflog4 = false;
      this.testflog = false;
    },
    hideTestbox3() {
      this.testflog3 = false;
      // this.imglogob = require("@/assets/pc/Logo/xia1.png");
    },
    showTestbox4() {
      this.testflog4 = true;
      //  this.imglogoc = require("@/assets/pc/Logo/shang1.png");
      this.testflog1 = false;
      this.testflog2 = false;
      this.testflog3 = false;
      this.testflog = false;
    },
    hideTestbox4() {
      this.testflog4 = false;
      //  this.imglogoc = require("@/assets/pc/Logo/xia1.png");
    },
    showTestbox() {
      this.testflog = true;
      this.imglogo1 = require("@/assets/pc/Logo/shang.png");
      this.testflog1 = false;
      this.testflog2 = false;
      this.testflog3 = false;
      this.testflog4 = false;
    },
    hideTestbox() {
      this.testflog = false;
      this.imglogo1 = require("@/assets/pc/Logo/xia.png");
    },
    loginafter() {
      this.getlist();
      this.$router.push({
        path: "/pc/Ownership",
        query: { userId: this.userId },
      });
    },
    //获取列表
    async getlist() {
      // if (
      //   this.userEmail == null ||
      //   this.userEmail == "" ||
      //   this.userEmail == undefined
      // ) {
      //   this.$message("Please log in again");
      //   this.$router.push("/pc/Index");
      //   return false;
      // }
      const params = {
        userId: this.userId,
        pageNum: 1,
        pageSize: 8,
        contractAddress: "",
      };

      //   console.log(params);
      let formData = new FormData();

      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }

      let config = {
        headers: {
          "Content-Type": "application/json",
          jwtToken: this.jwtToken,
        },
      }; //修改请求头

      // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
      let url = this.url + "verifiedContractList";
      axios
        .post(url, formData, config)
        .then((res) => {
          if (res.data.code == 200) {
          } else if (res.data.code == 401) {
            //  console.log("进行了异地登录");
            localStorage.removeItem("userId");
            localStorage.removeItem("email");
            localStorage.removeItem("jwtToken");
            // this.userEmail = null;
            this.$message("Please log in again");
            this.$router.push({
              path: "/pc/Index",
              query: { userEmail: "" },
            });
          }
          // if (res.data.result.code == 200) {
          //   this.lists = res.data.result.list;
          //   console.log(this.lists);

          // }
        })
        .catch((err) => {
          this.$message.error(err.message);
          //   console.log(err);
        });
    },
    back() {
      this.flogc = false;
      this.floag = true;
    },
    login() {
      this.floag = true;
    },
    emails(val) {
      this.userEmail = val;
    },
    signups(val) {
      //    console.log("接受注册传过来的值", val);
      this.flogb = val;
    },
    loginflog(val) {
      //   console.log("接受login的值", val);
      this.floag = val;
    },
    repwd(val) {
      //   console.log("接受重置repwd的值", val);
      this.flogc = val;
    },
    // handleSelect(key, keyPath) {
    //   //  console.log(key, keyPath);

    //   if (key == "2-1") {
    //     sessionStorage.removeItem("qingcu");

    //     sessionStorage.removeItem("tupian1");
    //     sessionStorage.removeItem("tupian");
    //     this.$router.push("/pc/BlockList");
    //   } else if (key == "2-2") {
    //     sessionStorage.removeItem("qingcu");
    //     sessionStorage.removeItem("tupian");
    //     sessionStorage.removeItem("tupian1");

    //     this.$router.push("/pc/TransactionsList");
    //   } else if (key == "2-3") {
    //     sessionStorage.removeItem("qingcu");
    //     sessionStorage.removeItem("tupian");
    //     sessionStorage.removeItem("tupian1");
    //     this.$router.push("/pc/Contracts");
    //   }
    // },

    Home() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "1-1";

      this.$router.push("/pc/index");
    },
    BlockList() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "";
      this.Scolor = "2-1";
      this.$router.push("/pc/BlockList");
    },

    Transactions() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "2-2";
      // this.$router.push("/pc/Indexa");
      this.$router.push("/pc/TransactionsList");
    },
    validators() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "5-1";
      this.$router.push("/pc/TopValidators");
    },
    Tokens() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "3-2";
      this.$router.push("/pc/TokensList");
    },
    TopTokens() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "3-1";
      this.$router.push("/pc/Tokens");
    },
    Contracts() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "2-3";
      this.$router.push("/pc/Contracts");
    },
    Accounts() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.$router.push("/pc/Accounts");
    },
    Overview() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.$router.push("/pc/Overview");
    },
    NFTs() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "4-1";
      this.$router.push("/pc/Topnfts");
      //this.$router.push("/pc/NFTs");
    },
    NFTslist() {
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian1");
      this.Scolor = "4-2";
      this.$router.push("/pc/NFTs");
    },
    Verify() {
      this.Scolor = "6-2";
      this.$router.push("/pc/Verify");
    },
    APIs() {
      this.Scolor = "6-3";
      this.$router.push("/pc/Apis");
    },
    Deployment() {
      this.Scolor = "6-1";
      this.$router.push("/pc/Deployment");
    },
  },
};
</script>
<style lang="less">
.el-message {
  margin-top: 150px !important;
}
</style>
<style lang="less" scoped>
// /deep/.el-massage{
// padding-top: 400px !important;
// }
// .el-massage{

// }
.Heater {
  width: 100%;
  background: #13161b;
  .Heater-W {
    width: 1160px;
    background: #13161b;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .logo {
    // flex: 1;
    font-size: 22px;
    font-family: SF Pro Display-Semibold, SF Pro Display;
    font-weight: 600;
    color: #ffffff;
    -webkit-background-clip: text;
    line-height: 60px;
    img {
      width: 40px;
      height: 38px;
      margin-right: 10px;
      margin-top: 20px;
    }
    .logo_All {
      cursor: pointer;
      display: flex;
      span {
        display: block;
        margin-top: 10px;
      }
    }
  }
  .Heater_menu {
    // height: 60px;
    position: relative;
    //连接测试网开始
    display: flex;
    margin-top: 29px;
    .Testnet1,
    .Testnet2,
    .Testnet3,
    .Testnet4,
    .Testnet5,
    .Testnet6 {
      // width: 67px;
      height: 32px;
      line-height: 32px;
      // background: #13161b;
      border-radius: 150px 150px 150px 150px;
      opacity: 1;
      z-index: 999999;

      .nettit {
        height: 32px;
        font-size: 14px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
        cursor: pointer;
      }
      .StartColor {
        color: #00e79a;
      }
      .netselect {
        margin-top: 8px;
        img {
          width: 18px;
          height: 16px;
          margin-left: 2px;
        }
      }
      .testbox {
        div {
          font-size: 14px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #ffffff;
        }
        .StartColor {
          color: #00e79a;
        }
      }
    }
    .Testnet1 {
      width: 67px;
    }
    .Testnet2 {
      width: 108px;
      .testbox {
        width: 108px;
        height: 112px;
      }
      // .active {
      //   width: 108px;
      //   height: 32px;
      //    text-align: center;
      //   background: #25272c;
      //   border-radius: 150px 150px 150px 150px;
      //   opacity: 1;
      //   .nettit {
      //     padding-left: 10px;
      //   }
      // }
    }
    .Testnet3 {
      .testbox {
        width: 134px;
        height: 80px;
        div {
          width: 134px;
        }
      }
      .testbox:hover {
        width: 134px;
        height: 80px;
        div {
          width: 134px;
        }
      }
    }
    .Testnet4 {
      .testbox {
        width: 127px;
        height: 80px;
        div {
          width: 127px;
        }
      }
      .testbox:hover {
        width: 127px;
        height: 80px;
        div {
          width: 127px;
        }
      }
    }
    .Testnet5 {
      width: 113px;
    }
    .Testnet6 {
      .testbox {
        width: 186px;
        height: 116px;
        div {
          width: 186px;
        }
      }
      .testbox:hover {
        width: 186px;
        height: 116px;
        div {
          width: 186px;
        }
      }
    }

    .Testnet {
      width: 107px;
      height: 32px;
      background: #252931;
      border-radius: 142px 142px 142px 142px;
      opacity: 1;
      display: flex;
      flex-direction: column;
      margin-left: 2px;
      z-index: 999999;
      // margin-top: 16px;
      cursor: pointer;
      .nettit {
        height: 32px;
        font-size: 14px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
        margin-left: 12px;
      }
      .netselect {
        width: 24px;
        height: 16px;
        border-radius: 10px;
        background: #00e79a;
        margin-top: 8px;
        margin-left: 15px;
        img {
          width: 14px;
          height: 11px;
          margin-top: 4px;
          margin-left: 5px;
        }
      }
    }
    .testbox {
      width: 107px;
      height: 80px;
      background: #252931;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      position: absolute;
      top: 46px;
      div {
        margin-top: 4px;
        margin-bottom: 4px;
        width: 107px;
        height: 32px;
        line-height: 32px;
        background: #252931;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        font-size: 14px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        cursor: pointer;
        span {
          margin-left: 12px;
        }
      }
      div:hover {
        margin-top: 4px;
        margin-bottom: 4px;
        width: 107px;
        height: 32px;
        line-height: 32px;
        background: #252931;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        font-size: 14px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #00e79a;
        cursor: pointer;
        span {
          //margin-left: 12px;
        }
      }
      .Mainnet {
        color: #fff !important;
      }
      .Mainnet:hover {
        color: #00e79a !important;
      }
      .Testnet:hover {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
    //连接测试网结束
    //登录之后
    .loginafter {
      // margin-top: 15px;
      display: flex;
      margin-left: 8px;
      cursor: pointer;
      img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
      div {
        height: 18px;
        font-size: 15px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #00e79a;
        line-height: 18px;
        margin-top: 10px;
        margin-left: 4px;
      }
    }
    //注册开始
    .signs {
      width: 83px;
      height: 35px;
      line-height: 35px;
      background: rgba(0, 231, 154, 0.98);
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      text-align: center;
      // margin-top: 15px;
      margin-left: 25px;
      font-size: 15px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #13161b;
      cursor: pointer;
    }
    ul {
      display: flex;
    }
    li:nth-child(2) {
      .Heater1 {
        text-align: center !important;
        // padding-left: 30px;

        height: 62px;
        line-height: 62px;
        h1 {
          margin-left: 0px;
        }
        // background: #000000;
        // border-radius: 10px 10px 10px 10px;
        // opacity: 1;
      }
    }
    li:nth-child(3) {
      .Heater1 {
        margin-right: 0px !important;
      }
    }
    .Heater1 {
      // border: 1px solid blue;
      margin-top: 10px;
      margin-right: 0px;
      width: 140px;
      height: 60px;
      text-align: center;
      // float: left;
      position: relative;
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 60px;
      // border: 1px solid blue;
      // -webkit-background-clip: text;
      cursor: pointer;

      i {
        position: absolute;
        top: 18px;
        right: 4px;
      }
    }

    .Heater1:hover {
      // background: #00E79A !important;
      color: #00e79a;
      // border: 1px solid red;
      background: #000;
      .p {
        display: block;
      }
    }
    .xialaa {
      position: absolute;
      top: 78px;
      left: 280px !important;
    }
    .xialab {
      position: absolute;
      top: 78px;
      left: 420px !important;
    }
    .xiala {
      width: 146px;
      height: 0;
      text-align: center;
      position: absolute;
      top: 78px;
      left: 140px;
      // border: 1px solid red;
      // background: #13161b;
      // border-radius: 12px 12px 12px 12px;
      z-index: 10;
      transition: all 0.3s;
      overflow: hidden;
      // padding: 0 0 0 20px;
      p {
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        // height: 64px;
        // line-height: 64px;
        height: 36px;
        line-height: 36px;
        cursor: pointer;
        // border: 1px solid yellow;
      }
      p:hover {
        color: #00a870 !important;
      }
    }
    .activea {
      height: 90px;
      background: #13161b;
      p {
        // border: 1px solid yellow;
        height: 45px;
        line-height: 45px;
        text-align: center;
      }
    }
    .activeb {
      height: 90px;
      background: #13161b;
      p {
        // border: 1px solid yellow;
        height: 45px;
        line-height: 45px;
      }
    }
    .active {
      transition: all 0.3s;
      // height: 128px;
      // padding: 0 0 20px 20px;
      // width: 157px;
      height: 138px;
      // padding-top: 10px;
      text-align: center;

      background: #13161b;

      p {
        // border: 1px solid yellow;
        height: 45px;
        line-height: 45px;
      }
      // border-radius: 12px 12px 12px 12px;
      opacity: 1;
    }
    .active1 {
      // background: #232a35;
      color: #00e79a;
      height: 62px;
      line-height: 62px;
      // background: #000000;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      text-align: center;
      // padding-right: 12px;
      // padding-left: 2px;
      // padding-right: 10px;
      font-family: Source Han Sans CN-Bold, Source Han Sans CN;
      font-weight: 700;
    }
    .active2 {
      color: #00e79a !important;
      // width: 157px;
      height: 62px;
      line-height: 62px;
      // background: #000000;
      // border-radius: 12px 12px 12px 12px;
      opacity: 1;
    }
  }
}
</style>
